import { defineStore } from 'pinia'
import { userVoiceSettingDetail } from '@/api/manage/userVoiceSetting'

export const useVoicePromptStore = defineStore('voicePrompt', {
  state: () => ({
    voicePromptEnabled: false,
    proxyDispensingVoicePromptEnabled: false,
  }),
  actions: {
    setChargeEnabled(enabled?: boolean) {
      if (typeof enabled === 'boolean') this.voicePromptEnabled = enabled
    },
    setPharmacyEnabled(enabled?: boolean) {
      if (typeof enabled === 'boolean') {
        this.proxyDispensingVoicePromptEnabled = enabled
      }
    },
    async loadSettings() {
      const result = await userVoiceSettingDetail()
      if (result?.code !== 0 || !result.data) return
      this.setChargeEnabled(result.data.chargeVoicePromptEnabled)
      this.setPharmacyEnabled(result.data.dispensingVoicePromptEnabled)
    },
  },
})
